module.exports = __webpack_public_path__ + "img/trailerRearLeft.359183f0.svg";